"use strict";

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createService;

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function createService(baseURL, storage) {
  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10000;

  var service = _axios["default"].create({
    baseURL: baseURL,
    timeout: timeout
  });

  service.interceptors.request.use(function (config) {
    var token = storage.getToken();

    if (token) {
      config.headers.authorization = "Bearer ".concat(token);
    }

    return config;
  }, function (error) {
    return Promise.reject(error);
  });
  return service;
}